import styled from "styled-components";

import OutlinedButton from "../../../../shared/components/buttons/OutlinedButton.styled";
import PrimaryButton from "../../../../shared/components/buttons/PrimaryButton.styled";
import { Summary } from "../../../../shared/styles/typography/Summary.styled";
import Card from "./Card.styled";

const AutomatedTools = styled(Card)`
  border-radius: ${({ theme }) => theme.borderRadiusPageCard};
  border: 1px solid ${({ theme }) => theme.colors.base3};

  ${Summary} {
    margin-bottom: 24px;
  }

  ${PrimaryButton}, ${OutlinedButton} {
    display: block;
    width: 100%;
  }
`;

export default AutomatedTools;
